var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('card-dashboard-oee',{attrs:{"oees_list":_vm.oees_list,"date_atm":_vm.date_list,"items_select":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }